import Calendar from 'react-calendar'
import { useState } from 'react'
import 'react-calendar/dist/Calendar.css'
import './PaymentPlan.css'

const getDateKey = (date) => {
  const year = date.getFullYear()
  const month = String(date.getMonth() + 1).padStart(2, '0')
  const day = String(date.getDate()).padStart(2, '0')
  return `${year}-${month}-${day}`
}

const getCalendarDate = (payment) => {
  const dateValue = payment.dueDate || payment.duedate
  const dateKey = String(dateValue).slice(0, 10)
  const [year, month, day] = dateKey.split('-').map(Number)
  return year && month && day ? new Date(year, month - 1, day) : null
}

const formatAmount = (amount) => `GH${Number(amount).toLocaleString()}`

function PaymentPlan({ overduePayments = [] }) {
  const [selectedDateKey, setSelectedDateKey] = useState('')
  const paymentEntries = Array.isArray(overduePayments)
    ? overduePayments.flatMap((payment) => Object.entries(payment))
    : Object.entries(overduePayments)
  const payments = paymentEntries.map(([debtor, payment]) => ({
    ...payment,
    debtor: payment.debtor || debtor,
  }))
  const firstPaymentDate = payments.map(getCalendarDate).find(Boolean)
  const selectedPayments = payments.filter(
    (payment) =>
      String(payment.dueDate || payment.duedate).slice(0, 10) ===
      selectedDateKey,
  )

  const getPaymentsForDate = (date) => {
    const dateKey = getDateKey(date)
    return payments.filter(
      (payment) =>
        String(payment.dueDate || payment.duedate).slice(0, 10) === dateKey,
    )
  }

  return (
    <section className='payment-plan' aria-labelledby='payment-plan-title'>
      <div className='payment-plan__header'>
        <div>
          <span className='app-content__eyebrow'>Collections</span>
          <h2 id='payment-plan-title'>Overdue payment plan</h2>
          <p>
            Outstanding invoice details are shown directly on overdue dates.
          </p>
        </div>
        <span className='payment-plan__status'>
          <i />
          {payments.length} overdue
        </span>
      </div>
      <div className='payment-plan__calendar'>
        <Calendar
          calendarType='gregory'
          defaultActiveStartDate={firstPaymentDate || undefined}
          showNeighboringMonth={false}
          tileClassName={({ date, view }) =>
            view === 'month' && getPaymentsForDate(date).length
              ? 'payment-plan__overdue-day'
              : null
          }
          tileContent={({ date, view }) => {
            const dayPayments = view === 'month' ? getPaymentsForDate(date) : []
            const dateKey = getDateKey(date)
            if (!dayPayments.length) return null

            return (
              <span
                className='payment-plan__marker'
                onMouseEnter={() => setSelectedDateKey(dateKey)}
                onClick={() => setSelectedDateKey(dateKey)}
              >
                <span className='payment-plan__dot' />
                <span
                  className='payment-plan__stack'
                  tabIndex='0'
                  onFocus={() => setSelectedDateKey(dateKey)}
                  aria-label={`${dayPayments.length} due payment plan${dayPayments.length === 1 ? '' : 's'}`}
                >
                  {dayPayments.length} due
                </span>
              </span>
            )
          }}
        />
      </div>
      {selectedPayments.length > 0 && (
        <section className='payment-plan__customers' aria-live='polite'>
          <strong>Customers due on {selectedDateKey}</strong>
          <div>
            {selectedPayments.map((payment, index) => (
              <span key={`${payment.invoice}-${index}`}>
                <b>{payment.debtor}</b>
                <small>Invoice {payment.invoice}</small>
                <em>{formatAmount(payment.amount)} owed</em>
              </span>
            ))}
          </div>
        </section>
      )}
      <div className='payment-plan__legend'>
        <i />
        Overdue payment due date
      </div>
    </section>
  )
}

export default PaymentPlan
